// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format17 } from '../../constants';

/** Ascension Island */
const AC: PhoneNumberData = [247, 'AC', 5, format17];

export default AC;
